import { blackColors, backgroundColor } from 'assets/jss/material-dashboard-pro-react';

const departmentCardStyle = (theme) => ({
	header: {
		'& p': {
			marginTop: '8px',
			marginBottom: 0,
		},
		[theme.browser.IE]: {
			'& > div': {
				padding: '0!important',
			},
		},
	},
	numbers: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg': {
			position: 'absolute',
			fontSize: '64px',
			left: '50%',
			top: '50%',
			transform: 'translate(-50%, -50%)',
			color: blackColors[6],
		},
		'& p': {
			marginBottom: 0,
			padding: '14px 0',
		},
	},
	cardFooter: {
		margin: 0,
		padding: '8px 16px 16px 16px',
		borderTop: `1px solid ${backgroundColor[0]}`,
		'& > div': {
			// grid container
			[theme.browser.IE]: {
				display: 'block',
			},
			'& > div': {
				// grid item
				[theme.browser.IE]: {
					display: 'inline-block',
					verticalAlign: 'middle',
				},
				'&:first-of-type': {
					flexGrow: 0,
					paddingRight: '0!important',
					'& svg': {
						marginTop: theme.direction === 'rtl' ? 6 : 0,
						fontSize: 24,
						color: blackColors[4],
					},
				},
				'&:last-of-type': {
					flexGrow: 1,
					maxWidth: 'calc(100% - 24px)',
					[theme.browser.IE]: {
						maxWidth: 'calc(100% - 64px)',
					},
					'& > p': {
						marginBottom: 4,
						marginTop: 4,
					},
					'& div': {
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						width: '100%',
						'& p': {
							display: 'inline',
						},
					},
				},
			},
		},
	},
	addNumbers: {
		'& button': {
			display: 'block',
			margin: '15px auto 20px',
		},
	},
	card: {
		height: 'calc(100% - 32px)',
		boxShadow: `0 8px 8px -6px ${blackColors[3]}`,
		transition: 'all .1s ease-in-out',
	},
	addNumbersContainer: {
		height: '100%',
	},
	cardHover: {
		cursor: 'pointer',
		'&:hover': {
			marginBottom: '17px',
			marginTop: '15px',
		},
		'&:active': {
			marginBottom: '15px',
			marginTop: '17px',
		},
	},
	cardDisabled: {
		boxShadow: 'none',
	},
});

export default departmentCardStyle;
